import axios from "axios";
import { getHeaders, URL } from "./config";

export const importProductsFromExcel = async (data, callback) => {
  const headers = await getHeaders();
  const url = `${URL}/importProductsFromExcel`;
  axios
    .post(url, data, { headers: headers })
    .then((response) => {
      if (response?.data) {
        callback({ status: 200, data: response?.data });
      }
    })
    .catch((error) => {
      callback({
        status: 400,
        message: error?.response?.data?.message || error?.message,
      });
    });
};

export const updateProductsFromExcel = async (filePath, previewOnly, callback) => {
  const headers = await getHeaders();
  const url = `${URL}/updateProductsFromExcel`;
  axios
    .post(url, { filePath, previewOnly }, { headers: headers })
    .then((response) => {
      if (response?.data) {
        callback({ status: 200, data: response?.data });
      }
    })
    .catch((error) => {
      callback({
        status: 400,
        message: error?.response?.data?.message || error?.message,
      });
    });
};

export const importMadePCProductsFromExcel = async (filePath, previewOnly, callback) => {
  const headers = await getHeaders();
  const url = `${URL}/importMadePCProductsFromExcel`;
  axios
    .post(url, { filePath, previewOnly }, { headers: headers })
    .then((response) => {
      if (response?.data) {
        callback({ status: 200, data: response?.data, success: true });
      }
    })
    .catch((error) => {
      callback({
        status: 400,
        message: error?.response?.data?.message || error?.message,
        success: false,
      });
    });
};

export const importGroupsFromExcel = async (filePath, preview = false, callback) => {
  let previewVal = false;
  let cb = callback;
  if (typeof preview === "function") {
    cb = preview;
    previewVal = false;
  } else if (typeof preview === "boolean") {
    previewVal = preview;
  }
  const headers = await getHeaders();
  const url = `${URL}/importGroupsFromExcel`;
  axios
    .post(url, { filePath, preview: previewVal, previewOnly: previewVal }, { headers: headers })
    .then((response) => {
      if (response?.data) {
        cb({ status: 200, data: response?.data, success: true });
      }
    })
    .catch((error) => {
      cb({
        status: 400,
        message: error?.response?.data?.message || error?.message,
        success: false,
      });
    });
};

export const importVariantsToGroupFromExcel = async (filePath, preview = false, callback) => {
  let previewVal = false;
  let cb = callback;
  if (typeof preview === "function") {
    cb = preview;
    previewVal = false;
  } else if (typeof preview === "boolean") {
    previewVal = preview;
  }
  const headers = await getHeaders();
  const url = `${URL}/importVariantsToGroupFromExcel`;
  axios
    .post(url, { filePath, preview: previewVal, previewOnly: previewVal }, { headers: headers })
    .then((response) => {
      if (response?.data) {
        cb({ status: 200, data: response?.data, success: true });
      }
    })
    .catch((error) => {
      cb({
        status: 400,
        message: error?.response?.data?.message || error?.message,
        success: false,
      });
    });
};



export const syncProductToQuickBooks = async (productId, callback) => {
  const headers = await getHeaders();
  const url = `${URL}/syncProductToQuickBooks?productId=${productId}`;
  axios
    .post(url, {}, { headers: headers })
    .then((response) => {
      if (response?.data) {
        callback({ status: 200, data: response?.data });
      }
    })
    .catch((error) => {
      callback({
        status: 400,
        message: error?.response?.data?.message || error?.message,
      });
    });
};
export const humanizeProductDescription = async (data, callback) => {
  const headers = await getHeaders();
  const url = `${URL}/humanizeProductDescription`;
  axios
    .post(url, data, { headers: headers })
    .then((response) => {
      if (response?.data) {
        callback({ status: 200, data: response?.data });
      }
    })
    .catch((error) => {
      callback({
        status: 400,
        message: error?.response?.data?.message || error?.message,
      });
    });
};

export const bulkHumanizeProductDescriptions = async (payload, callback) => {
  const headers = await getHeaders();
  const url = `${URL}/bulkHumanizeProductDescriptions`;
  axios
    .post(url, payload, { headers: headers })
    .then((response) => {
      if (response?.data) {
        callback({ status: 200, data: response?.data, success: true });
      }
    })
    .catch((error) => {
      callback({
        status: 400,
        message: error?.response?.data?.message || error?.message,
        success: false,
      });
    });
};

export const getAdminProductDetails = async (slug, callback) => {
  const headers = await getHeaders();
  const url = `${URL}/getAdminProductDetails?slug=${slug}`;
  axios
    .get(url, { headers: headers })
    .then((response) => {
      if (response?.data) {
        callback({ status: 200, data: response?.data });
      }
    })
    .catch((error) => {
      callback({
        status: 400,
        message: error?.response?.data?.message || error?.message,
      });
    });
};

export const getPurchasedItems = async (
  pageSize,
  page,
  startDate,
  endDate,
  searchTerm,
  callback
) => {
  const headers = await getHeaders();
  const url = `${URL}/getPurchasedItems?pageSize=${pageSize}&page=${page}&startDate=${startDate}&endDate=${endDate}&searchTerm=${searchTerm}`;
  axios
    .get(url, { headers: headers })
    .then((response) => {
      if (response?.data) {
        callback({ status: 200, data: response?.data });
      }
    })
    .catch((error) => {
      callback({
        status: 400,
        message: error?.response?.data?.message || error?.message,
      });
    });
};

export const getMyReviews = async (
  pageSize,
  page,
  sortBy,
  sortOrder,
  searchTerm,
  callback
) => {
  const headers = await getHeaders();
  const url = `${URL}/getMyReviews?pageSize=${pageSize}&page=${page}&sortBy=${sortBy}&sortOrder=${sortOrder}&searchTerm=${searchTerm}`;
  axios
    .get(url, { headers: headers })
    .then((response) => {
      if (response?.data) {
        callback({ status: 200, data: response?.data });
      }
    })
    .catch((error) => {
      callback({
        status: 400,
        message: error?.response?.data?.message || error?.message,
      });
    });
};

export const listProductGroups = async (
  pageSize,
  page,
  sortBy,
  sortOrder,
  mfg_id,
  categoryId,
  searchTerm,
  groupType,
  callback
) => {
  const headers = await getHeaders();
  const cleanSearch = (searchTerm || "").trim();
  const cleanGroupType = (groupType || "").trim();
  const cleanMfgId = (mfg_id || "").trim();
  const cleanCategoryId = (categoryId || "").trim();

  let params = [];
  params.push(`pageSize=${pageSize || 10}`);
  params.push(`page=${page || 1}`);
  if (sortBy) params.push(`sortBy=${sortBy}`);
  if (sortOrder) params.push(`sortOrder=${sortOrder}`);
  if (cleanMfgId) {
    params.push(`mfg_id=${encodeURIComponent(cleanMfgId)}`);
    params.push(`mfgId=${encodeURIComponent(cleanMfgId)}`);
  }
  if (cleanCategoryId) {
    params.push(`categoryId=${encodeURIComponent(cleanCategoryId)}`);
    params.push(`category_id=${encodeURIComponent(cleanCategoryId)}`);
  }
  if (cleanGroupType) {
    params.push(`groupType=${encodeURIComponent(cleanGroupType)}`);
    params.push(`type=${encodeURIComponent(cleanGroupType)}`);
  }
  if (cleanSearch) {
    params.push(`searchTerm=${encodeURIComponent(cleanSearch)}`);
    params.push(`search=${encodeURIComponent(cleanSearch)}`);
    params.push(`name=${encodeURIComponent(cleanSearch)}`);
    params.push(`query=${encodeURIComponent(cleanSearch)}`);
    params.push(`q=${encodeURIComponent(cleanSearch)}`);
  }

  const payload = {
    pageSize: pageSize || 10,
    page: page || 1,
    sortBy: sortBy || "date_created",
    sortOrder: sortOrder || "desc",
    mfg_id: cleanMfgId,
    mfgId: cleanMfgId,
    categoryId: cleanCategoryId,
    category_id: cleanCategoryId,
    groupType: cleanGroupType,
    type: cleanGroupType,
    searchTerm: cleanSearch,
    search: cleanSearch,
    name: cleanSearch,
    query: cleanSearch,
    q: cleanSearch
  };

  const url = `${URL}/listProductGroups?${params.join("&")}`;
  
  // Try POST first (standard for Firebase Cloud Functions in this project), then fallback to GET
  axios
    .post(url, payload, { headers: headers })
    .then((response) => {
      if (response?.data) {
        callback({ status: 200, data: response?.data });
      }
    })
    .catch((postError) => {
      axios
        .get(url, { headers: headers })
        .then((response2) => {
          if (response2?.data) {
            callback({ status: 200, data: response2?.data });
          }
        })
        .catch((getError) => {
          callback({
            status: 400,
            message: getError?.response?.data?.message || postError?.response?.data?.message || getError?.message || postError?.message,
          });
        });
    });
};

export const updateProductGroup = async (data, callback) => {
  const headers = await getHeaders();
  const url = `${URL}/updateProductGroup`;
  axios
    .post(url, data, { headers: headers })
    .then((response) => {
      if (response?.data) {
        callback({ status: 200, data: response?.data });
      }
    })
    .catch((error) => {
      callback({
        status: 400,
        message: error?.response?.data?.message || error?.message,
      });
    });
};

export const getProductGroup = async (groupId, callback) => {
  const headers = await getHeaders();
  const url = `${URL}/getProductGroup?groupId=${groupId}`;
  axios
    .get(url, { headers: headers })
    .then((response) => {
      if (response?.data) {
        callback({ status: 200, data: response?.data });
      }
    })
    .catch((error) => {
      callback({
        status: 400,
        message: error?.response?.data?.message || error?.message,
      });
    });
};

export const deleteProductGroup = async (groupId, callback) => {
  const headers = await getHeaders();
  const url = `${URL}/deleteProductGroup`;
  axios
    .post(url, { groupId }, { headers: headers })
    .then((response) => {
      if (response?.data) {
        callback({ status: 200, data: response?.data, success: true });
      }
    })
    .catch((error) => {
      callback({
        status: 400,
        message: error?.response?.data?.message || error?.message,
      });
    });
};

export const bulkEditVariantAttributes = async (data, callback) => {
  const headers = await getHeaders();
  const url = `${URL}/bulkEditVariantAttributes`;
  axios
    .post(url, data, { headers: headers })
    .then((response) => {
      if (response?.data) {
        callback({ status: 200, data: response?.data, success: true });
      }
    })
    .catch((error) => {
      callback({
        status: 400,
        message: error?.response?.data?.message || error?.message,
      });
    });
};

export const addVariantToGroup = async (data, callback) => {
  const headers = await getHeaders();
  const url = `${URL}/addVariantToGroup`;
  axios
    .post(url, data, { headers: headers })
    .then((response) => {
      if (response?.data) {
        callback({ status: 200, data: response?.data });
      }
    })
    .catch((error) => {
      callback({
        status: 400,
        message: error?.response?.data?.message || error?.message,
      });
    });
};

export const removeVariantFromGroup = async (data, callback) => {
  const headers = await getHeaders();
  const url = `${URL}/removeVariantFromGroup`;
  axios
    .post(url, data, { headers: headers })
    .then((response) => {
      if (response?.data) {
        callback({ status: 200, data: response?.data, success: true });
      }
    })
    .catch((error) => {
      callback({
        status: 400,
        message: error?.response?.data?.message || error?.message,
      });
    });
};

export const reorderVariants = async (data, callback) => {
  const headers = await getHeaders();
  const url = `${URL}/reorderVariants`;
  axios
    .post(url, data, { headers: headers })
    .then((response) => {
      if (response?.data) {
        callback({ status: 200, data: response?.data, success: true });
      }
    })
    .catch((error) => {
      callback({
        status: 400,
        message: error?.response?.data?.message || error?.message,
      });
    });
};

export const createProductGroup = async (data, callback) => {
  const headers = await getHeaders();
  console.log("Headers", headers);
  const url = `${URL}/createProductGroup`;
  axios
    .post(url, data, { headers: headers })
    .then((response) => {
      if (response?.data) {
        callback({ status: 200, data: response?.data });
      }
    })
    .catch((error) => {
      callback({
        status: 400,
        message: error?.response?.data?.message || error?.message,
      });
    });
};

export const migrateToGroup = async (data, callback) => {
  const headers = await getHeaders();
  const url = `${URL}/migrateToGroup`;
  axios
    .post(url, data, { headers: headers })
    .then((response) => {
      if (response?.data) {
        callback({ status: 200, data: response?.data, success: true });
      }
    })
    .catch((error) => {
      callback({
        status: 400,
        message: error?.response?.data?.message || error?.message,
      });
    });
};

export const getManufacturers = async (callback) => {
  const headers = await getHeaders();
  const url = `${URL}/getManufacturers`;
  axios
    .get(url, { headers: headers })
    .then((response) => {
      if (response?.data) {
        callback({ status: 200, data: response?.data, success: true });
      }
    })
    .catch((error) => {
      axios
        .post(url, {}, { headers: headers })
        .then((response) => {
          if (response?.data) {
            callback({ status: 200, data: response?.data, success: true });
          }
        })
        .catch((err2) => {
          callback({
            status: 400,
            message: err2?.response?.data?.message || err2?.message,
          });
        });
    });
};
